import {
  API_CALL_ERROR,
  API_CALL_PENDING,
  API_CALL_SUCCESSFUL,
  ApiState,
  NOT_CALLED
} from "@/common/store/util/ApiStates";
import { AxiosPromise } from "axios";

interface ResponseType<K> {
  response: any,
  requestParameter: K
}

interface ErrorType<K> {
  error: String,
  requestParameter: K
}

export class AsyncState<T, K> {
  private entity: string;
  public data: T;
  public callState: {
    state: ApiState,
    lastRequestParameters: K,
    error: String
  };

  constructor(storeAttribute: string, data: T, initialRequestParameters: K) {
    this.entity = storeAttribute;

    this.data = data;
    this.callState = {
      state: NOT_CALLED,
      lastRequestParameters: initialRequestParameters,
      error: ''
    };
  }

  getConstants() {
    const uppercaseEntity = this.entity.toUpperCase();
    return {
      DATA: uppercaseEntity,
      LOADING: uppercaseEntity + '_LOADING',
      LOADED: uppercaseEntity + '_LOADED',
      LAST_REQUEST_PARAMS: uppercaseEntity + '__LAST_REQUEST_PARAMS',

      FETCH: 'FETCH_' + uppercaseEntity,

      CALLED: 'FETCH_' + uppercaseEntity + '_CALLED',
      SUCCESSFUL: 'FETCH_' + uppercaseEntity + '_SUCCESSFUL',
      FAILED: 'FETCH_' + uppercaseEntity + '_FAILED'
    };
  }

  defaultGetters<S>() {
    return {
      // @ts-ignore
      [this.getConstants().DATA]: (state: S) => state[this.entity].data,
      // @ts-ignore
      [this.getConstants().LOADING]: (state: S) => state[this.entity].callState.state === API_CALL_PENDING,
      // @ts-ignore
      [this.getConstants().LOADED]: (state: S) => state[this.entity].callState.state === API_CALL_SUCCESSFUL,
      // @ts-ignore
      [this.getConstants().LAST_REQUEST_PARAMS]: (state: S) => state[this.entity].callState.lastRequestParameters
    };
  }

  defaultMutations<S>() {
    return {
      [this.getConstants().CALLED]: (state: S, requestParam: K) => {
        // @ts-ignore
        state[this.entity].callState.state = API_CALL_PENDING;
        // @ts-ignore
        state[this.entity].callState.lastRequestParameters = requestParam;
      },
      [this.getConstants().SUCCESSFUL]: (state: S, payload: ResponseType<K>) => {
        // @ts-ignore
        if (JSON.stringify(state[this.entity].callState.lastRequestParameters) === JSON.stringify(payload.requestParameter)) {
          // @ts-ignore
          state[this.entity].callState.state = API_CALL_SUCCESSFUL;
          // @ts-ignore
          state[this.entity].data = payload.response;
        }
      },
      [this.getConstants().FAILED]: (state: S, payload: ErrorType<K>) => {
        // @ts-ignore
        if (JSON.stringify(state[this.entity].callState.lastRequestParameters) === JSON.stringify(payload.requestParameter)) {
          // @ts-ignore
          state[this.entity].callState.state = API_CALL_ERROR;
          // @ts-ignore
          state[this.entity].callState.error = payload.error;
          // @ts-ignore
          state[this.entity].data = [];
        }
      }
    };
  }

  asyncApiCall(store: any, apiCall: AxiosPromise<any>, requestParams: K, mapper?: Function) {
    if (store.getters[this.getConstants().LOADING] && JSON.stringify(store.getters[this.getConstants().LAST_REQUEST_PARAMS]) === JSON.stringify(requestParams)) {
      return;
    }

    store.commit(this.getConstants().CALLED, requestParams);

    apiCall
      .then(resp => {

        if (mapper) {
          store.commit(this.getConstants().SUCCESSFUL, {
            response: mapper(resp),
            requestParameter: requestParams
          } as ResponseType<K>);
        } else {
          store.commit(this.getConstants().SUCCESSFUL, {
            response: resp.data,
            requestParameter: requestParams
          } as ResponseType<K>);
        }

      })
      .catch(err => {
        store.commit(this.getConstants().FAILED, { error: err, requestParameter: requestParams } as ErrorType<K>);
      });
  }
}
